import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=f4b95d88&scoped=true&"
import script from "./cost.vue?vue&type=script&lang=js&"
export * from "./cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b95d88",
  null
  
)

export default component.exports